import { useState, useEffect } from 'react';
import orderApi from '_api/order';
import { BUYER_ORDER_PAID, BUYER_ORDER_COLLECTED } from '_utils/constant';

export default function useHasPaidOrder(eid) {
  const [hasPaidOrder, setHasPaidOrder] = useState(false);

  useEffect(() => {
    if (eid) {
      orderApi
        .getListOrdersByEventId(eid)
        .then(({ msgResp }) => {
          if (Array.isArray(msgResp)) {
            const hasPaid = msgResp.some(
              (order) =>
                order.buyerStatus === BUYER_ORDER_PAID ||
                order.buyerStatus === BUYER_ORDER_COLLECTED
            );
            setHasPaidOrder(hasPaid);
          }
        })
        .catch((err) => {
          console.error('Error fetching event orders:', err);
        });
    } else {
      setHasPaidOrder(false);
    }
  }, [eid]);

  return hasPaidOrder;
}
